import { PaymentDue, WorkoutPlan } from '@willow/types-iso';

export const getActiveOrCompletedWorkoutPlanForPaymentDue = (
  workoutPlans: WorkoutPlan[],
  paymentDue: PaymentDue,
  atDate?: Date, // timestamp
): WorkoutPlan | undefined =>
  workoutPlans.find(
    (workoutPlan) =>
      (workoutPlan.status === 'active' || workoutPlan.status === 'completed') &&
      'paymentDueIds' in workoutPlan &&
      (workoutPlan.paymentDueIds ?? []).includes(paymentDue.id) &&
      (atDate ? workoutPlan.createdAt <= atDate : true),
  );
